import type { Envelope } from '../../types';
import { getFromStorage } from '../storage-api-utils';
import { isEnvelope } from './isEnvelope';
import { isExpired } from './isExpired';
import { removeEnvelope } from './removeEnvelope';

export const readEnvelope = (
    envelopeKey: string,
    metadataKey: string,
    ttlMs: number,
    storage: Storage
): Envelope | null => {
    const raw = getFromStorage(envelopeKey, storage);

    if (raw === null) return null;

    if (!isEnvelope(raw)) {
        // данные старого формата (до envelope) или мусор — удаляем
        removeEnvelope(envelopeKey, metadataKey, storage);
        return null;
    }

    if (isExpired(raw.savedAt, ttlMs)) {
        // протухшие данные тоже сразу удаляем
        removeEnvelope(envelopeKey, metadataKey, storage);
        return null;
    }

    return raw;
};
